module.exports = __webpack_public_path__ + "media/bgm.7d6783c7.mp3";